import React, { useEffect, useRef, useState } from "react";

// The look the brand asks for; the SDK maps it to whichever wallet button it draws.
const WALLET_BUTTON_OPTIONS = Object.freeze({ color: "black" });

// The SDK draws the wallet button of the selected option: Google's, Apple's or the provider's own (Trust).
// Each click pays through payAsync, so the brand only supplies the click-time data and handles the result.
function WalletButton({ sdk, paymentOption, getData, onResult }) {
  const hostRef = useRef(null);
  const [state, setState] = useState("loading");

  const getDataRef = useRef(getData);
  const onResultRef = useRef(onResult);
  useEffect(() => {
    getDataRef.current = getData;
    onResultRef.current = onResult;
  }, [getData, onResult]);

  useEffect(() => {
    let active = true;
    let dispose = null;

    const renderButton = async () => {
      setState("loading");

      const rendered = await sdk.renderWalletButtonAsync({
        paymentOption,
        element: hostRef.current,
        buttonOptions: WALLET_BUTTON_OPTIONS,
        getData: () => getDataRef.current?.(),
        onResult: (result) => onResultRef.current?.(result)
      });

      if (!active) {
        rendered.dispose?.();
        return;
      }

      dispose = rendered.dispose ?? null;
      setState(rendered.rendered ? "shown" : "unavailable");
    };

    renderButton();

    return () => {
      active = false;
      dispose?.();
    };
  }, [sdk, paymentOption]);

  return (
    <div className="wallet-button-panel">
      <div className="wallet-button-host" ref={hostRef}></div>
      {state === "loading" && <div className="wallet-message">Loading...</div>}
      {state === "unavailable" && (
        <div className="wallet-message">
          {paymentOption.displayName || paymentOption.dataType} is not available
        </div>
      )}
    </div>
  );
}

export default WalletButton;
